import { NgModule } from '@angular/core';
import { ProfessionalComponent } from './professional.component';
import { ProfessionalRoutingModule } from './professional-routing.module';
import { SharedModule } from '../../../shared/shared.module';
import { JobMetasResolver } from './job-metas-resolver';
import { JobNavigationGuard } from './guards/job-navigation.guard';
import { ProListingPageGuard } from './pro-listing/pro-listing-page.guard.guard';
import { StyleMetasResolver } from './style-metas-resolver';
import { StylesResolver } from './styles-resolver';
import { ServiceTypesMetasResolver } from './service-types-metas-resolver';
import { ServiceTypesResolver } from './service-types-resolver';
import { CityMetasResolver } from 'src/app/modules/pro/professional/city-metas-resolver';
import { ProServiceApiModule } from '@adeo/ngx-kozikaza-api/pro/service';
import { ProNavigationService } from "./pro-navigation.service";

@NgModule({
  imports: [
    ProServiceApiModule,
    SharedModule,
    ProfessionalRoutingModule
  ],
  declarations: [
    ProfessionalComponent
  ],
  providers: [
    ProNavigationService,
    JobMetasResolver,
    CityMetasResolver,
    JobNavigationGuard,
    ProListingPageGuard,
    StyleMetasResolver,
    StylesResolver,
    ServiceTypesMetasResolver,
    ServiceTypesResolver,
  ]
})
export class ProfessionalModule { }
